/*
    © 2022 EcomGradautes.com
    https://www.ecomgraduates.com
*/

// Ajax 'Add To Cart' (ATC) forms
window.onSubmitAtcForm = async (form, event) => {
    event.preventDefault()

    const btn = form.querySelector('button[name="add"]')
    const oldBtnInnerHtml = btn.innerHTML

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })

    btn.innerHTML = oldBtnInnerHtml

    if (document.querySelector('#offcanvas-cart')) {
        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    }

    window.refreshCartContents()
}

// Product Options - listen for onchange events
window.onChangeProductOption = async (input) => {
    const productPackSize = document.querySelector('.product-options-pack-size')
    const form = input.closest('form')
    const addToCartBtn = form.querySelector('[name="add"]')

    const response = await fetch(`/products/${input.dataset.productHandle}.js`)
    const productData = await response.json()

    const productOptions = []
    form.querySelectorAll('.product-option').forEach(el => {
        if (el.type === 'radio') {
            if (el.checked) {
                productOptions.push(el.value)
                if(productPackSize){
                  productPackSize.innerHTML = el.value
                  }
            }
        } else {
            productOptions.push(el.value)
        }
    })

    const selectedVariant = productData.variants.find(variant =>
        variant.title.includes(productOptions.toString().replace(',', ' / '))
    )

    console.log(selectedVariant)
    if (selectedVariant) {
        form.querySelector('[name="id"]').value = selectedVariant.id

        if (selectedVariant.available) {
            addToCartBtn.disabled = false
            addToCartBtn.querySelector('.btn-atc-text').innerHTML = window.themeStrings.addToCart
        } else {
            addToCartBtn.disabled = true
            addToCartBtn.querySelector('.btn-atc-text').innerHTML = window.themeStrings.soldOut
        }

        if (selectedVariant.compare_at_price) {
            form.querySelector('.product-price-compare').style.display = 'inline-block'
            form.querySelector('.product-price-compare s').textContent = window.formatMoney(selectedVariant.compare_at_price)
        } else {
            form.querySelector('.product-price-compare').style.display = 'none'
            form.querySelector('.product-price-compare s').textContent = ''
        }

        form.querySelector('.product-price-final').textContent = window.formatMoney(selectedVariant.price)
        form.querySelector('.product-price-final').setAttribute('data-current-variant-price', selectedVariant.price)

        if (form.closest('.product')) {
            const url = new URL(window.location)
            url.searchParams.set('variant', selectedVariant.id)
            window.history.replaceState({}, '', url)
        }

        const customEvent = new CustomEvent('variantChange.product', {
            detail: selectedVariant
        })
        window.dispatchEvent(customEvent)
    } else {
        addToCartBtn.disabled = true
        addToCartBtn.querySelector('.btn-atc-text').innerHTML = window.themeStrings.unavailable
    }

    adjustPricePerBagPDP()
}

// Product Media Gallery - Init Splide
const initProductMediaGalleryMobile = () => {
    const elem = document.querySelector('#product-media-gallery-mobile')

    if (!elem) { return }

    const main = new Splide(elem.querySelector('.splide-main'), {
        type: 'loop',
        pagination: false,
        arrows: false,
        gap: '1rem',
        padding: { left: '3rem', right: '3rem' },
        mediaQuery: 'min'
    })

    main.mount()
}
initProductMediaGalleryMobile()

const initProductMediaGalleryDesktop = () => {
    document.querySelectorAll('.product-media-gallery-desktop').forEach(elem => {
        const main = new Splide(elem.querySelector('.splide-main'), {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: false
        })

        const thumbs = new Splide(elem.querySelector('.splide-thumbs'), {
            gap: 12,
            rewind: true,
            arrows: true,
            pagination: false,
            perPage: 5,
            isNavigation: true,
            breakpoints: {
                575: {
                    perPage: 4,
                    gap: 8
                }
            }
        })

        thumbs.on('arrows:mounted', () => {
            document.querySelectorAll('.product-media-gallery .splide__arrow').forEach(arrow => {
                arrow.innerHTML = `
                    <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.63722 0.249906C9.41012 0.372425 9.26854 0.605395 9.26854 0.858785V4.80443L1.47779 4.80443C1.08441 4.80443 0.765137 5.11629 0.765137 5.50055C0.765137 5.88481 1.08441 6.19668 1.47779 6.19668L9.26854 6.19668V10.1423C9.26854 10.3966 9.41012 10.6296 9.63722 10.7512C9.86432 10.8746 10.1418 10.8663 10.3613 10.7317L17.9021 6.08994C18.1093 5.96185 18.2347 5.74002 18.2347 5.50055C18.2347 5.26108 18.1093 5.03925 17.9021 4.91117L10.3613 0.269398C10.2454 0.198857 10.1133 0.162659 9.98119 0.162659C9.86337 0.162659 9.74459 0.19236 9.63722 0.249906Z" fill="white"/>
                    </svg>
                `
            })
        })

        window.addEventListener('variantChange.product', (event) => {
            const selectedVariant = event.detail

            if (selectedVariant.featured_media) {
                main.go(selectedVariant.featured_media.position - 1)
            }
        }, false)

        main.sync(thumbs)
        main.mount()
        thumbs.mount()
    })
}
initProductMediaGalleryDesktop()

// Flavors change in the product form (PDP)
window.onChangeProductFormFlavor = async (input, event) => {
    window.history.replaceState({}, '', `/products/${input.value}`)

    const classList = Array.from(document.querySelectorAll('[name="flavors"]')).map(el => el.value)
    document.documentElement.classList.remove(...classList)
    document.documentElement.classList.add(input.value)

    document.querySelector('.product').style.opacity = '.25'

    const reponse = await fetch(window.location.href)
    const data = await reponse.text()
    const newDoc = new DOMParser().parseFromString(data, 'text/html')

    document.title = newDoc.title
    document.querySelector('.product').replaceWith(newDoc.querySelector('.product'))
    document.querySelector('.ingredients-section')?.replaceWith(newDoc.querySelector('.ingredients-section'))
    document.querySelector('.simple-image')?.replaceWith(newDoc.querySelector('.simple-image'))
    document.querySelector('.advanced-slider-main-slide .btn')?.replaceWith(newDoc.querySelector('.advanced-slider-main-slide .btn'))

    if (document.querySelector('.parallax-image')) {
        document.querySelector('.parallax-image')?.replaceWith(newDoc.querySelector('.parallax-image'))
        jarallax(document.querySelector('.parallax-image.jarallax'))
    }

    setTimeout(() => {
        document.querySelector('.okeReviews-widget-holder')?.replaceWith(newDoc.querySelector('.okeReviews-widget-holder'))
        window.refreshOkendo()
    }, 5000)

    // Safari needed fix
    document.querySelector('#product-media-gallery-col').style.opacity = 0
    document.querySelector('#product-media-gallery-col').style.transition = 'all .2s ease-out'
    setTimeout(() => {
        document.querySelector('#product-media-gallery-col').style.opacity = 1
    }, 250)

    initProductMediaGalleryMobile()
    initProductMediaGalleryDesktop()
    adjustPricePerBagPDP()
    initPurchaseOptions()
}

// Flavors change in the subscribe form (sub page)
window.onChangeSubFormFlavor = async (input, event) => {
    document.querySelectorAll('.sub-main-form').forEach(section => {
        section.setAttribute('hidden', 'hidden')
    })

    const section = document.querySelector(`#sub-main-form-${input.value}`)
    section.removeAttribute('hidden')

    const classList = Array.from(document.querySelectorAll('[name="flavors"]')).map(el => el.value)
    document.documentElement.classList.remove(...classList)
    document.documentElement.classList.add(input.value)

    initProductMediaGalleryMobile()
    initProductMediaGalleryDesktop()
}

// Delivery options buttons in the subscribe form (sub page)
window.onClickDeliveryOptionBtn = (btn, event) => {
    console.log(btn.closest('form'))
    btn.closest('.sub-main-form-times').querySelector('#sub-main-form-delivery-option').textContent = btn.textContent

    const sellingPlanSelector = document.querySelector('select[name="selling_plan"]')

    if (sellingPlanSelector) {
        sellingPlanSelector.value = btn.dataset.sellingPlanId
        sellingPlanSelector.dispatchEvent(new Event('change'))
    }
}

// Restock notify app fix styling
setInterval(() => {
    const btn = document.querySelector('.restockify-notify-button')
    if (btn) {
        btn.classList.add('btn-primary', 'mt-5', 'mb-0')
    }
}, 1000)

// Calc and update price per bag in the Product highlight metafield
const adjustPricePerBagPDP = () => {
    const elem = document.querySelector('#product-highlights ul')

    if (!elem) {
        return
    }

    if (document.querySelector('#product-highlights-price-change')) {
        document.querySelector('#product-highlights-price-change').remove()
    }

    const qty = Number(document.querySelector('[name="product-form-quantity"]:checked').dataset.qty)
    const price = Number(document.querySelector('[data-current-variant-price]').dataset.currentVariantPrice)

    elem.insertAdjacentHTML('afterbegin', `
        <li id="product-highlights-price-change">${qty} bags = <span>${window.formatMoney((price / qty))} a bag</span> </li>
    `)
}
adjustPricePerBagPDP()

const adjustPricePerBagSubPage = () => {
    document.querySelectorAll('.sub-form-delivery-highlights').forEach(list => {
        list.querySelector('.delivery-highlights-price-change')?.remove()

        const qty = Number(list.closest('form').querySelector('[name="id"]:checked').dataset.qty)
        const priceFinal = Number(list.closest('.sub-main-form-times').querySelector('[data-price-final]').dataset.priceFinal)
        const priceCompare = Number(list.closest('.sub-main-form-times').querySelector('[data-price-compare]').dataset.priceCompare)

        list.insertAdjacentHTML('afterbegin', `
            <li class="delivery-highlights-price-change d-flex align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-check me-2" viewBox="0 0 16 16">
                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"></path>
                </svg>
                ${qty} bags = <span class="ms-2" style="color: red; font-weight: 700;"> ${window.formatMoney((priceFinal / qty))} a bag</span> 
                <s class="ms-2">${window.formatMoney((priceCompare / qty))} a bag</s>
            </li>
        `)
    })
}

document.querySelectorAll('input[name="id"]').forEach(input => {
    input.addEventListener('click', () => {
        adjustPricePerBagSubPage()
    })
})

adjustPricePerBagSubPage()

// Klaviyo back in stock feature
window.onSubmitKlaviyoBackInStock = async (form, event) => {
    event.preventDefault()

    const email = form.querySelector('[type="email"]').value
    const variant = Number(form.dataset.variantId)
    const product = Number(form.dataset.productId)

    const res = await fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
        method: 'POST',
        headers: {
            accept: 'application/json, text/plain, */*',
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: new URLSearchParams({
            a: 'H4JvXz',
            platform: 'shopify',
            email,
            variant,
            product
        })
    })

    console.log(res)

    if (res.ok) {
        form.querySelector('.form-inner').setAttribute('hidden', 'hidden')
        form.querySelector('.alert').removeAttribute('hidden')
    }
}

// Purchase options (selling/subscription plans)
const initPurchaseOptions = () => {
    const wrapper = document.querySelector('#product-purchase-options')

    if (!wrapper) return

    console.log(wrapper)

    wrapper.querySelectorAll('[name="purchase_option"]').forEach(input => {
        input.addEventListener('change', () => {
            if (input.id === 'purchase-options-one-time') {
                wrapper.querySelector('#purchase-delivery-options').setAttribute('hidden', 'hidden')
                wrapper.querySelector('[name="selling_plan"]').disabled = true
                document.querySelector('.product .btn-atc .product-price-final').textContent = window.formatMoney(input.dataset.price)
                const savingBadge = document.querySelector('.product .product-form-radio-option:checked + label .badge')
                savingBadge.textContent = `Save ${savingBadge.dataset.oneTimeSave}`
            } else {
                wrapper.querySelector('#purchase-delivery-options').removeAttribute('hidden')
                wrapper.querySelector('[name="selling_plan"]').disabled = false
                document.querySelector('.product .btn-atc .product-price-final').textContent = window.formatMoney(input.dataset.price)
                const savingBadge = document.querySelector('.product .product-form-radio-option:checked + label .badge')
                savingBadge.textContent = `Save ${savingBadge.dataset.subSave}`
            }
        })
    })

    document.querySelectorAll('.product .product-option').forEach(el => {
        el.addEventListener('change', async () => {
            document.querySelector('#product-purchase-options').style.opacity = '.25'

            await new Promise(resolve => setTimeout(resolve, 500))

            const reponse = await fetch(window.location.href)
            const data = await reponse.text()
            const newDoc = new DOMParser().parseFromString(data, 'text/html')

            document.querySelector('#product-purchase-options').replaceWith(newDoc.querySelector('#product-purchase-options'))

            initPurchaseOptions()
        })
    })
}
initPurchaseOptions()

window.onClickProductFormDeliveryOptionBtn = (btn) => {
    const wrapper = document.querySelector('#purchase-delivery-options')

    wrapper.querySelector('[name="selling_plan"]').value = btn.dataset.sellingPlanId
    wrapper.querySelector('[data-bs-toggle="dropdown"]').textContent = btn.textContent
}
